import LinkOutlined from "@ant-design/icons/LinkOutlined";
import Title from "common/Typography/Title";
import styled from "styled-components";
import Text from "common/Typography/Text";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface WhitelistIPsMessageProps {
  primaryExchange?: string;
}

const WhitelistIPsMessage = ({ primaryExchange }: WhitelistIPsMessageProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  return (
    <SecurityMessageWrapper $size={"S"} type="secondary" as="div">
      <LinkOutlined />
      <Title
        level={5}
        type="secondary"
        style={{ marginLeft: 4, display: "inline" }}
      >
        {t("create_account.quick_connect")}
      </Title>{" "}
      {t("create_account.quick_connect_description")} {primaryExchange}
    </SecurityMessageWrapper>
  );
};
export default WhitelistIPsMessage;

const SecurityMessageWrapper = styled(Text)`
  text-align: left;
  margin-top: 16px;
  margin-bottom: 0;
  padding-top: 12px;
  border-top: ${(p) => p.theme.borders.light};
`;
